import * as React from 'react';
import { connect } from 'react-redux';
import * as Redux from 'redux';
import styled from 'styled-components';
import { translate } from "react-i18next";

const TableWrapper = styled.div`
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;
`;

const Title = styled.div`
    margin-top: 40px;
    margin-bottom: 20px;
`;

const Table = styled.table`
    height: calc(100% - 4px);
    border-collapse: collapse;
    th {
        text-align: left;
        border-bottom: 2px solid #265a9c;
    };  
    tr {
        font-size: 15px;
    };
    tr:last-child {
        border-bottom: 2px solid #265a9c;
        padding-bottom: 10px;
    };
    tr:last-child>td {
        padding-bottom: 10px;
    };
    td {
        padding: 10px 0 0 10px;
    };
    div {
        display: flex;
        text-align: left;
        align-items: flex-start;
    };
    input[type="date"] {
      width: 156px;
      height: 16px;
    }
`;

class InstanceAdmin extends React.Component {
    getInstanceList() {
        const { instances, t } = this.props;
        const instancesList = instances.map((instance) =>
            <tr key={instance.id}>
                <td>
                    {instance.name}
                </td>
                <td>
                    <a href={`https://${instance.host}`}>{instance.host}</a>
                </td>
                <td>
                    {instance.registerCustomerAllowed ?  t('Yes') : t('No')}
                </td>
            </tr>
        )

        return <Table>
                <thead>
                    <tr>
                        <th>{t('Name')}</th>
                        <th>Host</th>
                        <th>{t('RegisterCustomerAllowed')}</th>
                    </tr>
                </thead>
                <tbody>
                    {instancesList}
                </tbody>
            </Table>
    }

    render() {
        const { t, instances } = this.props;

        return (
            <React.Fragment>
                {instances.length > 0
                    ? <React.Fragment>
                        <Title style={{marginTop: '20px'}}>{t('Instances')}:</Title>
                        <TableWrapper> {this.getInstanceList()} </TableWrapper>
                    </React.Fragment>
                    : null}
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(InstanceAdmin));



// WEBPACK FOOTER //
// ./src/containers/content/grid/adminPanel/instanceAdmin/InstanceAdmin.jsx